<h3 mat-dialog-title>{{ 'cameras.schedule.title' | t }}</h3>
<mat-dialog-content>
  <mat-form-field>
    <mat-label>{{ 'common.timezone' | t }}</mat-label>
    <mat-select [(ngModel)]="timezone" [placeholder]="'common.timezone' | t">
      <mat-option *ngFor="let tz of timezoneOptions" [value]="tz">{{ tz }}</mat-option>
    </mat-select>
  </mat-form-field>
  <sn-weekly-scheduler
    [schedules]="data.aiDetectionTypes[0]?.schedules"
    (saveClick)="setSchedules($event)"
  ></sn-weekly-scheduler>
  <button mat-button class="cancelButton" color="warn" type="button" (click)="cancel()">
    {{ 'common.close' | t }}
  </button>
</mat-dialog-content>
